//import {  } from "core-js/fn/promise";
import html2canvas from "html2canvas";
import { mapConfig } from "../../map.config";

const uploadBlobToServer = (img, callback) => {

    const formData = new FormData();
    formData.append('base64', img);
  
    let url = 'https://upload.senstate.com/upload-blob';
  
    var xhr = new XMLHttpRequest();
  
    xhr.upload.onprogress = function(event) {
      let percent = Math.round(100 * event.loaded / event.total);
      console.log(`File is ${percent} uploaded.`);
    };
  
    xhr.upload.onerror = function() {
      console.log(`Error during the upload: ${xhr.status}.`);
      callback(xhr.status)
    };
  
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        callback(xhr.response);
      }
    }
  
    xhr.open('POST', url, true);
    xhr.send(formData);
  }
  
  const getImage = (container) => {
    return new Promise ((resolve, reject) => {

    const activeMap = mapConfig.active; // 0 - maptiler, 1 - mapbox
  
    switch(activeMap){
      case 0:
        let svgTopLeft = document.querySelector('svg.leaflet-zoom-animated').attributes['viewBox'].value.split(' ');
        let left = 0;
        let top = 0;
        if(svgTopLeft.length){
          let svgLeft = parseInt(svgTopLeft[0]);
          let svgTop = parseInt(svgTopLeft[1]);
          if(svgLeft < -900){
            svgLeft = -154;
            svgTop = -66;
          }
          left = (svgLeft * (-2)).toString() + 'px';
          top = (svgTop * (-2)).toString() + 'px';
        }
        document.getElementsByClassName('leaflet-overlay-pane')[0].style.top = top;
        document.getElementsByClassName('leaflet-overlay-pane')[0].style.left = left;
        break;
      
      default:
    }
      
      
    
      const options = {
        useCORS: true,
        allowTaint: true,
        //scale: 3,
        backgroundColor: window.navigator.userAgent.indexOf('Firefox') > -1 ? "#ffffff" : null,
        //width: window.screen.availWidth,
        //width: document.body.style.width,
        //height: window.screen.availHeight,
        //height: document.body.style.height - 77,
        //windowWidth: document.body.scrollWidth,
        //windowHeight: document.body.scrollHeight,
        //x: 0,
        //y: window.scrollY
        removeContainer: false,
      }
      
      html2canvas(container, options).then(function(canvas) {

        
        let img = canvas.toDataURL("image/jpeg", 1);
        // only download picture for testing purpose, uncomment following fragment until end test
          
        // Following rows are for testing
        //var aEl = document.createElement('a');
        //aEl.href = img;
        //aEl.download = '*.jpg';
        //aEl.click();
      
        //return null;

        // testing till here
          
        // end test
        if(activeMap === 0) { // Maptiler
          document.getElementsByClassName('leaflet-overlay-pane')[0].style.top = 0;
          document.getElementsByClassName('leaflet-overlay-pane')[0].style.left = 0;
        }
        /*
        img = new Image();
        let mapCanvas = document.querySelector('.mapboxgl-canvas');
        img.src = mapCanvas.toDataURL();
        window.document.body.appendChild(img);
        */

        /*
        canvas.toBlob((blob) => {
          const img = new Image();
          const url = URL.createObjectURL(blob);

          //******** JUST FOR TEST ***************
          //******** Comment the following line for production
          window.open(url, '_blank');
          //********* END TEST ************


          img.onload = () => {
            // no longer need to read the blob so it's revoked
            URL.revokeObjectURL(url);
          };

          img.src = url;
          //document.body.appendChild(img);

          uploadBlobToServer(img, (resp) => {
            return callback(resp);
          });

        }, 'image/jpeg', 1);
        */

        uploadBlobToServer(img, (resp) => {
          resolve(resp);
        });

        
        
      });
    
  });
}

  export { getImage };